import React from "react";
import { TListingValuationTabOutput } from "../../../../domain/codecs/formIO/ListingValuationTabFormIO";
import { CRMListingEmbargoBanner } from "../CRMListingEmbargoBanner/CRMListingEmbargoBanner";
import { TListingFull1Editable } from "../../../../domain/codecs/formEditable/ListingEditable";
import { TListingDataFormIO } from "../../../../domain/codecs/formIO/ListingDataFormIO";
import { SpacingColumn } from "../BuildingBlocks/SpacingColumn";
import { SpacingRow } from "../BuildingBlocks/SpacingRow";
import { CRMSpacing } from "../../models/CRMSpacing";
import { CRMSpacingColumn } from "../CRMSpacingColumn/CRMSpacingColumn";
import { CRMCardOutside } from "../CRMCardOutside/CRMCardOutside";
import { CRMPadding } from "../Simple/CRMPadding/CRMPadding";
import { CRMValuationStatusBar } from "./CRMValuationStatusBar";
import { CRMValuationSpine } from "./CRMValuationSpine";
import { CRMValuationAnswerCard } from "./CRMValuationAnswerCard";
import { CRMValuationReasonCard } from "./CRMValuationReasonCard";
import { CRMValuationComparablesCard } from "./CRMValuationComparablesCard";
import { CRMValuationDetailsCard } from "./CRMValuationDetailsCard";
import { CRMValuationBookingForm } from "../CRMValuationBookingForm/CRMValuationBookingForm";
import { CRMListingSpecificsForm } from "../CRMListingSpecificsForm/CRMListingSpecificsForm";
import { TOnValuationAction } from "./valuationTabSteps";
import { CRMValuationActionResult } from "./CRMValuationActionResult";
import { TListingValuationActionFormIO } from "../../../../domain/codecs/formIO/ListingValuationActionFormIO";

export const CRMListingPageValuation = (props: {
    output: TListingValuationTabOutput;
    listingId: string;
    listingPageData: TListingDataFormIO;
    actionForm: TListingValuationActionFormIO;
    isSubmitting: boolean;
    onAction: TOnValuationAction;
    onListingChange: (form: TListingFull1Editable) => void;
}): JSX.Element => (
    <SpacingColumn spacing={CRMSpacing.LARGE}>
        <CRMListingEmbargoBanner doNotContactUntil={props.output.do_not_contact_until}>
            {" "}Comparables and the title check can be done now — it is the call to the family that waits.
        </CRMListingEmbargoBanner>

        <CRMValuationStatusBar output={props.output} />

        <SpacingRow spacing={CRMSpacing.X_LARGE} childSize="1fr 2fr" alignItems="flex-start">
            {/* COLUMN - FORM */}
            <SpacingColumn spacing={CRMSpacing.LARGE}>
                <CRMCardOutside
                    borderRounding="right"
                    shadow={true}
                >
                    <CRMPadding size="large">
                        <CRMSpacingColumn spacing="large">
                            <CRMValuationBookingForm
                                listingForm={props.listingPageData.output.form}
                                onChange={props.onListingChange}
                            />
                            {/* The same specifics form Preparation uses. The beds,
                                baths and floor area the engine prices from are these
                                columns; a second editor for them on this tab would be
                                two ways to write one field. */}
                            <CRMListingSpecificsForm
                                listingPageData={props.listingPageData}
                                onChange={props.onListingChange}
                            />
                        </CRMSpacingColumn>
                    </CRMPadding>
                </CRMCardOutside>
            </SpacingColumn>

            {/* COLUMN - SIDEBAR */}
            <SpacingColumn spacing={CRMSpacing.LARGE}>
                <CRMValuationActionResult form={props.actionForm} />
                <CRMValuationSpine
                    output={props.output}
                    isSubmitting={props.isSubmitting}
                    onAction={props.onAction}
                />
                <CRMValuationAnswerCard
                    output={props.output}
                    isSubmitting={props.isSubmitting}
                    onAction={props.onAction}
                />
                <CRMValuationReasonCard output={props.output} />
                <CRMValuationComparablesCard output={props.output} />
                <CRMValuationDetailsCard
                    output={props.output}
                    isSubmitting={props.isSubmitting}
                    onAction={props.onAction}
                />
            </SpacingColumn>
        </SpacingRow>
    </SpacingColumn>
);
